<template>
	<div class="main-containter" v-title data-title="和华利盛-首页">
		<PHeader :checkId="'加入我们34'"  :activeNames="'联系我们'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">加入我们</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">Join Us</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 / 加入我们</span>
				<span style="color:#333333;font-size:14px;"> / 岗位详情</span>
			</div>
			<div style="margin-top: 10px;margin-left: 3%;width: 94%;">
				<div style="height:100px;width:100%;">
					<img style="height:100%;width:100%;" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/joinus.png">
				</div>
				<div style="margin-top: 30px;font-size: 14px;">
					发布日期：{{item.publish.substring(0,10)}}
				</div>
				<div style="margin-top: 15px;font-weight: 900;font-size: 18px;color: #333333;">
					{{item.name}}
				</div>
				<div style="margin-top: 15px;font-size: 14px;color: rgb(51, 51, 51);padding-bottom: 15px;">
					{{item.type+" | "+item.address+" | "+'简历投递：'}}<span style="color:#98273A;">{{item.email}}</span>
				</div>
				<div style="width: 100%;height: 1px;background-size: 20px 10px;background-repeat: repeat-x;background-image: linear-gradient(to right, #D7D7D7 0%, #D7D7D7 50%, transparent 75%);"></div>
				<div style="margin-top: 20px;color: #333333;">
					岗位职责:
				</div>
				<div style="white-space: pre-wrap;margin-top: 20px;font-size: 14px;color: #555555;line-height: 25px;">{{item.responsibility}}</div>
				<div style="margin-top: 20px;color: #333333;">
					任职资格:
				</div>
				<div style="white-space: pre-wrap;margin-top: 20px;font-size: 14px;color: #555555;line-height: 25px;margin-bottom:50px;">{{item.qualification}}</div>
			</div>
			
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {queryNext} from "@/api/joinUs";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				item: {},
			}
		},
		created() {
			this.item = JSON.parse(this.$route.query.item)
		},
		mounted() {
			this.item = JSON.parse(this.$route.query.item)
		},
		activated() {
			this.item = JSON.parse(this.$route.query.item)
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter /deep/ .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel /deep/ .el-carousel__container{
		height: 100%;
	}
	body /deep/ .v-modal{
		display: none;
	}
</style>
